import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as claimApi from '../services/claimApi';

export const verifyClaim = createAsyncThunk(
  'claim/verifyClaim',
  async (username, { rejectWithValue }) => {
    try {
      const res = await claimApi.verifyClaim(username);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Failed to verify profile'
      );
    }
  }
);

const claimSlice = createSlice({
  name: 'claim',
  initialState: {
    loading: false,
    error: null,
  },
  reducers: {
    clearClaimState: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyClaim.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyClaim.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(verifyClaim.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearClaimState } = claimSlice.actions;
export default claimSlice.reducer;
